module.exports = __webpack_public_path__ + "Server-Unhealthy-Ssh.cadf28e57d66a9288b71a237152422bf.hashedasset.svg";